export const ADD_FILTER = 'filters/ADD_FILTER'
export const INIT_FILTER_FORM = 'filters/INIT_FILTER_FORM'
export const REMOVE_FILTER = 'filters/REMOVE_FILTER'
export const RESET = 'filters/RESET'
export const SET_ERROR = 'filters/SET_ERROR'
export const SET_FILTER_FORM = 'filters/SET_FILTER_FORM'
